import script from "./match_r.vue?vue&type=script&setup=true&lang=js"
export * from "./match_r.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__